/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  OrganizationFormDTO,
  OrganizationFormListItemDTOQueryResultDTO,
  OrganizationFormResponseReviewDTO,
  OrganizationFormSubmissionListItemDTOQueryResultDTO,
  OrganizationFormsGetFormsParams,
  OrganizationFormsGetSubmittedResponsesParams,
  UpsertOrganizationFormDTO
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





export const organizationFormsGetForms = (
    organizationId: number,
    params?: OrganizationFormsGetFormsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationFormListItemDTOQueryResultDTO>(
      {url: `/api/organizations/${organizationId}/admin/OrganizationForms`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getOrganizationFormsGetFormsQueryKey = (organizationId: number,
    params?: OrganizationFormsGetFormsParams,) => {
    return [`/api/organizations/${organizationId}/admin/OrganizationForms`, ...(params ? [params]: [])] as const;
    }

    
export const getOrganizationFormsGetFormsQueryOptions = <TData = Awaited<ReturnType<typeof organizationFormsGetForms>>, TError = ErrorType<unknown>>(organizationId: number,
    params?: OrganizationFormsGetFormsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFormsGetForms>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationFormsGetFormsQueryKey(organizationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationFormsGetForms>>> = ({ signal }) => organizationFormsGetForms(organizationId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationFormsGetForms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationFormsGetFormsQueryResult = NonNullable<Awaited<ReturnType<typeof organizationFormsGetForms>>>
export type OrganizationFormsGetFormsQueryError = ErrorType<unknown>


export function useOrganizationFormsGetForms<TData = Awaited<ReturnType<typeof organizationFormsGetForms>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params: undefined |  OrganizationFormsGetFormsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFormsGetForms>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationFormsGetForms>>,
          TError,
          Awaited<ReturnType<typeof organizationFormsGetForms>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationFormsGetForms<TData = Awaited<ReturnType<typeof organizationFormsGetForms>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: OrganizationFormsGetFormsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFormsGetForms>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationFormsGetForms>>,
          TError,
          Awaited<ReturnType<typeof organizationFormsGetForms>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationFormsGetForms<TData = Awaited<ReturnType<typeof organizationFormsGetForms>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: OrganizationFormsGetFormsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFormsGetForms>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOrganizationFormsGetForms<TData = Awaited<ReturnType<typeof organizationFormsGetForms>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: OrganizationFormsGetFormsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFormsGetForms>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationFormsGetFormsQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const organizationFormsCreateForm = (
    organizationId: number,
    upsertOrganizationFormDTO: UpsertOrganizationFormDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationFormDTO>(
      {url: `/api/organizations/${organizationId}/admin/OrganizationForms`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: upsertOrganizationFormDTO, signal
    },
      );
    }
  


export const getOrganizationFormsCreateFormMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationFormsCreateForm>>, TError,{organizationId: number;data: UpsertOrganizationFormDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof organizationFormsCreateForm>>, TError,{organizationId: number;data: UpsertOrganizationFormDTO}, TContext> => {
    
const mutationKey = ['organizationFormsCreateForm'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationFormsCreateForm>>, {organizationId: number;data: UpsertOrganizationFormDTO}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  organizationFormsCreateForm(organizationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationFormsCreateFormMutationResult = NonNullable<Awaited<ReturnType<typeof organizationFormsCreateForm>>>
    export type OrganizationFormsCreateFormMutationBody = UpsertOrganizationFormDTO
    export type OrganizationFormsCreateFormMutationError = ErrorType<unknown>

    export const useOrganizationFormsCreateForm = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationFormsCreateForm>>, TError,{organizationId: number;data: UpsertOrganizationFormDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof organizationFormsCreateForm>>,
        TError,
        {organizationId: number;data: UpsertOrganizationFormDTO},
        TContext
      > => {

      const mutationOptions = getOrganizationFormsCreateFormMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const organizationFormsGetForm = (
    organizationId: number,
    formId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationFormDTO>(
      {url: `/api/organizations/${organizationId}/admin/OrganizationForms/${formId}`, method: 'GET', signal
    },
      );
    }
  

export const getOrganizationFormsGetFormQueryKey = (organizationId: number,
    formId: number,) => {
    return [`/api/organizations/${organizationId}/admin/OrganizationForms/${formId}`] as const;
    }

    
export const getOrganizationFormsGetFormQueryOptions = <TData = Awaited<ReturnType<typeof organizationFormsGetForm>>, TError = ErrorType<unknown>>(organizationId: number,
    formId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFormsGetForm>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationFormsGetFormQueryKey(organizationId,formId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationFormsGetForm>>> = ({ signal }) => organizationFormsGetForm(organizationId,formId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && formId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationFormsGetForm>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationFormsGetFormQueryResult = NonNullable<Awaited<ReturnType<typeof organizationFormsGetForm>>>
export type OrganizationFormsGetFormQueryError = ErrorType<unknown>


export function useOrganizationFormsGetForm<TData = Awaited<ReturnType<typeof organizationFormsGetForm>>, TError = ErrorType<unknown>>(
 organizationId: number,
    formId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFormsGetForm>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationFormsGetForm>>,
          TError,
          Awaited<ReturnType<typeof organizationFormsGetForm>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationFormsGetForm<TData = Awaited<ReturnType<typeof organizationFormsGetForm>>, TError = ErrorType<unknown>>(
 organizationId: number,
    formId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFormsGetForm>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationFormsGetForm>>,
          TError,
          Awaited<ReturnType<typeof organizationFormsGetForm>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationFormsGetForm<TData = Awaited<ReturnType<typeof organizationFormsGetForm>>, TError = ErrorType<unknown>>(
 organizationId: number,
    formId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFormsGetForm>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOrganizationFormsGetForm<TData = Awaited<ReturnType<typeof organizationFormsGetForm>>, TError = ErrorType<unknown>>(
 organizationId: number,
    formId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFormsGetForm>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationFormsGetFormQueryOptions(organizationId,formId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const organizationFormsUpdateForm = (
    organizationId: number,
    formId: number,
    upsertOrganizationFormDTO: UpsertOrganizationFormDTO,
 ) => {
      
      
      return customInstance<OrganizationFormDTO>(
      {url: `/api/organizations/${organizationId}/admin/OrganizationForms/${formId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: upsertOrganizationFormDTO
    },
      );
    }
  


export const getOrganizationFormsUpdateFormMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationFormsUpdateForm>>, TError,{organizationId: number;formId: number;data: UpsertOrganizationFormDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof organizationFormsUpdateForm>>, TError,{organizationId: number;formId: number;data: UpsertOrganizationFormDTO}, TContext> => {
    
const mutationKey = ['organizationFormsUpdateForm'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationFormsUpdateForm>>, {organizationId: number;formId: number;data: UpsertOrganizationFormDTO}> = (props) => {
          const {organizationId,formId,data} = props ?? {};

          return  organizationFormsUpdateForm(organizationId,formId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationFormsUpdateFormMutationResult = NonNullable<Awaited<ReturnType<typeof organizationFormsUpdateForm>>>
    export type OrganizationFormsUpdateFormMutationBody = UpsertOrganizationFormDTO
    export type OrganizationFormsUpdateFormMutationError = ErrorType<unknown>

    export const useOrganizationFormsUpdateForm = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationFormsUpdateForm>>, TError,{organizationId: number;formId: number;data: UpsertOrganizationFormDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof organizationFormsUpdateForm>>,
        TError,
        {organizationId: number;formId: number;data: UpsertOrganizationFormDTO},
        TContext
      > => {

      const mutationOptions = getOrganizationFormsUpdateFormMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const organizationFormsPublish = (
    organizationId: number,
    formId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationFormDTO>(
      {url: `/api/organizations/${organizationId}/admin/OrganizationForms/${formId}/publish`, method: 'POST', signal
    },
      );
    }
  


export const getOrganizationFormsPublishMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationFormsPublish>>, TError,{organizationId: number;formId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof organizationFormsPublish>>, TError,{organizationId: number;formId: number}, TContext> => {
    
const mutationKey = ['organizationFormsPublish'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationFormsPublish>>, {organizationId: number;formId: number}> = (props) => {
          const {organizationId,formId} = props ?? {};

          return  organizationFormsPublish(organizationId,formId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationFormsPublishMutationResult = NonNullable<Awaited<ReturnType<typeof organizationFormsPublish>>>
    
    export type OrganizationFormsPublishMutationError = ErrorType<unknown>

    export const useOrganizationFormsPublish = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationFormsPublish>>, TError,{organizationId: number;formId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof organizationFormsPublish>>,
        TError,
        {organizationId: number;formId: number},
        TContext
      > => {

      const mutationOptions = getOrganizationFormsPublishMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const organizationFormsArchive = (
    organizationId: number,
    formId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationFormDTO>(
      {url: `/api/organizations/${organizationId}/admin/OrganizationForms/${formId}/archive`, method: 'POST', signal
    },
      );
    }
  


export const getOrganizationFormsArchiveMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationFormsArchive>>, TError,{organizationId: number;formId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof organizationFormsArchive>>, TError,{organizationId: number;formId: number}, TContext> => {
    
const mutationKey = ['organizationFormsArchive'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationFormsArchive>>, {organizationId: number;formId: number}> = (props) => {
          const {organizationId,formId} = props ?? {};

          return  organizationFormsArchive(organizationId,formId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationFormsArchiveMutationResult = NonNullable<Awaited<ReturnType<typeof organizationFormsArchive>>>
    
    export type OrganizationFormsArchiveMutationError = ErrorType<unknown>

    export const useOrganizationFormsArchive = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationFormsArchive>>, TError,{organizationId: number;formId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof organizationFormsArchive>>,
        TError,
        {organizationId: number;formId: number},
        TContext
      > => {

      const mutationOptions = getOrganizationFormsArchiveMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const organizationFormsGetSubmittedResponses = (
    organizationId: number,
    formId: number,
    params?: OrganizationFormsGetSubmittedResponsesParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationFormSubmissionListItemDTOQueryResultDTO>(
      {url: `/api/organizations/${organizationId}/admin/OrganizationForms/${formId}/responses`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getOrganizationFormsGetSubmittedResponsesQueryKey = (organizationId: number,
    formId: number,
    params?: OrganizationFormsGetSubmittedResponsesParams,) => {
    return [`/api/organizations/${organizationId}/admin/OrganizationForms/${formId}/responses`, ...(params ? [params]: [])] as const;
    }

    
export const getOrganizationFormsGetSubmittedResponsesQueryOptions = <TData = Awaited<ReturnType<typeof organizationFormsGetSubmittedResponses>>, TError = ErrorType<unknown>>(organizationId: number,
    formId: number,
    params?: OrganizationFormsGetSubmittedResponsesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFormsGetSubmittedResponses>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationFormsGetSubmittedResponsesQueryKey(organizationId,formId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationFormsGetSubmittedResponses>>> = ({ signal }) => organizationFormsGetSubmittedResponses(organizationId,formId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && formId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationFormsGetSubmittedResponses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationFormsGetSubmittedResponsesQueryResult = NonNullable<Awaited<ReturnType<typeof organizationFormsGetSubmittedResponses>>>
export type OrganizationFormsGetSubmittedResponsesQueryError = ErrorType<unknown>


export function useOrganizationFormsGetSubmittedResponses<TData = Awaited<ReturnType<typeof organizationFormsGetSubmittedResponses>>, TError = ErrorType<unknown>>(
 organizationId: number,
    formId: number,
    params: undefined |  OrganizationFormsGetSubmittedResponsesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFormsGetSubmittedResponses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationFormsGetSubmittedResponses>>,
          TError,
          Awaited<ReturnType<typeof organizationFormsGetSubmittedResponses>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationFormsGetSubmittedResponses<TData = Awaited<ReturnType<typeof organizationFormsGetSubmittedResponses>>, TError = ErrorType<unknown>>(
 organizationId: number,
    formId: number,
    params?: OrganizationFormsGetSubmittedResponsesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFormsGetSubmittedResponses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationFormsGetSubmittedResponses>>,
          TError,
          Awaited<ReturnType<typeof organizationFormsGetSubmittedResponses>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationFormsGetSubmittedResponses<TData = Awaited<ReturnType<typeof organizationFormsGetSubmittedResponses>>, TError = ErrorType<unknown>>(
 organizationId: number,
    formId: number,
    params?: OrganizationFormsGetSubmittedResponsesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFormsGetSubmittedResponses>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOrganizationFormsGetSubmittedResponses<TData = Awaited<ReturnType<typeof organizationFormsGetSubmittedResponses>>, TError = ErrorType<unknown>>(
 organizationId: number,
    formId: number,
    params?: OrganizationFormsGetSubmittedResponsesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFormsGetSubmittedResponses>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationFormsGetSubmittedResponsesQueryOptions(organizationId,formId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const organizationFormsGetSubmittedResponse = (
    organizationId: number,
    formId: number,
    responseId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationFormResponseReviewDTO>(
      {url: `/api/organizations/${organizationId}/admin/OrganizationForms/${formId}/responses/${responseId}`, method: 'GET', signal
    },
      );
    }
  

export const getOrganizationFormsGetSubmittedResponseQueryKey = (organizationId: number,
    formId: number,
    responseId: number,) => {
    return [`/api/organizations/${organizationId}/admin/OrganizationForms/${formId}/responses/${responseId}`] as const;
    }

    
export const getOrganizationFormsGetSubmittedResponseQueryOptions = <TData = Awaited<ReturnType<typeof organizationFormsGetSubmittedResponse>>, TError = ErrorType<unknown>>(organizationId: number,
    formId: number,
    responseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFormsGetSubmittedResponse>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationFormsGetSubmittedResponseQueryKey(organizationId,formId,responseId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationFormsGetSubmittedResponse>>> = ({ signal }) => organizationFormsGetSubmittedResponse(organizationId,formId,responseId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && formId && responseId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationFormsGetSubmittedResponse>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationFormsGetSubmittedResponseQueryResult = NonNullable<Awaited<ReturnType<typeof organizationFormsGetSubmittedResponse>>>
export type OrganizationFormsGetSubmittedResponseQueryError = ErrorType<unknown>


export function useOrganizationFormsGetSubmittedResponse<TData = Awaited<ReturnType<typeof organizationFormsGetSubmittedResponse>>, TError = ErrorType<unknown>>(
 organizationId: number,
    formId: number,
    responseId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFormsGetSubmittedResponse>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationFormsGetSubmittedResponse>>,
          TError,
          Awaited<ReturnType<typeof organizationFormsGetSubmittedResponse>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationFormsGetSubmittedResponse<TData = Awaited<ReturnType<typeof organizationFormsGetSubmittedResponse>>, TError = ErrorType<unknown>>(
 organizationId: number,
    formId: number,
    responseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFormsGetSubmittedResponse>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationFormsGetSubmittedResponse>>,
          TError,
          Awaited<ReturnType<typeof organizationFormsGetSubmittedResponse>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationFormsGetSubmittedResponse<TData = Awaited<ReturnType<typeof organizationFormsGetSubmittedResponse>>, TError = ErrorType<unknown>>(
 organizationId: number,
    formId: number,
    responseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFormsGetSubmittedResponse>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useOrganizationFormsGetSubmittedResponse<TData = Awaited<ReturnType<typeof organizationFormsGetSubmittedResponse>>, TError = ErrorType<unknown>>(
 organizationId: number,
    formId: number,
    responseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFormsGetSubmittedResponse>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationFormsGetSubmittedResponseQueryOptions(organizationId,formId,responseId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



